module.exports = __webpack_public_path__ + "static/media/MCOIN-UST.27ef8b13.svg";